<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>{{details.title}}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" xs="12" md="3">
        <v-img :src="details.imageUrl" alt="image" contain max-height="220"></v-img>
      </v-col>
      <v-col cols="12" sm="4" xs="12" md="3">
        <h4>Details</h4>
        <v-list dense>
          <v-list-item two-line max-height="10" height="10">
            <v-list-item-content style="pa-0">
              <v-list-item-title>Brewery</v-list-item-title>
              <v-list-item-subtitle>{{details.brewery}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content style="pa-0">
              <v-list-item-title>Country</v-list-item-title>
              <v-list-item-subtitle>
                <span :class="'flag-icon flag-icon-' + details.countryCode"></span>
                {{details.countryName}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Style</v-list-item-title>
              <v-list-item-subtitle>
                <template v-for="style in details.styles">
                    <v-chip class="mr-1 " color="primary" outlined small :key="style.styleId" >
                      {{style.title}}
                    </v-chip>
                </template>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Alcohol Content</v-list-item-title>
              <v-list-item-subtitle>{{details.abv}} %ABV</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line v-if="details.ibu > 0">
            <v-list-item-content>
              <v-list-item-title>Bitterness</v-list-item-title>
              <v-list-item-subtitle>{{details.ibu}} IBU</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line v-if="details.ebc > 0">
            <v-list-item-content>
              <v-list-item-title>Color</v-list-item-title>
              <v-list-item-subtitle>{{details.ebc}} ebc</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line v-if="details.tempC > 0">
            <v-list-item-content>
              <v-list-item-title>Serving Temp</v-list-item-title>
              <v-list-item-subtitle>{{details.tempC}} °C - {{details.tempF}} °F</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>


      </v-col>
      <v-col cols="12" sm="5" xs="12" md="3">
        <h4>Global Ratings</h4>
        <v-list dense>
          <template v-for="rating in details.ratingsGlobal">

            <v-list-item two-line :key="rating.ratingId">
              <v-list-item-content>
                <v-list-item-title>{{rating.name}}</v-list-item-title>
                <v-list-item-subtitle>
                  <v-rating v-model="rating.rating" background-color="grey darken-1" half-increments dense hover readonly></v-rating>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </template>

        </v-list>
      </v-col>
      <v-col cols="12" sm="5" xs="12" md="3">
        <h4>Your Ratings</h4>
        <v-list dense>
          <template v-for="rating in details.ratingsUser">

            <v-list-item two-line :key="rating.ratingId">
              <v-list-item-content>
                <v-list-item-title>{{rating.name}}</v-list-item-title>
                <v-list-item-subtitle>
                  <v-rating v-model="rating.rating" background-color="grey darken-1" half-increments dense hover @input="onUserRatingChangend(rating)"></v-rating>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </template>

        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
         <v-textarea v-model="details.notes" @change="onTastingNotesChange" rows="2" name="input-7-1" label="Your tasting notes" value="" outlined clearable auto-grow dense></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <span v-html="details.description"></span>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
// https://github.com/lipis/flag-icon-css
export default {
  name: 'Beer',
  props: {
    beerId: Number,
  },
  components: {
  },
  // props: {
  //   beerId: {
  //     type: Number,
  //     default: 0,
  //   },
  // },
  data() {
    return {
      details: [],
    };
  },
  created() {
    // this.beerId = this.$route.params.beerId;
    const data = {
      beerId: this.beerId,
    };

    this.$webConn.request('app2_get_beer_details', data).then((result) => {
      this.details = result.Beer;
    }).catch((error) => {
      alert(error.Message);
    });
  },
  methods: {
    onUserRatingChangend(rating) {
      const data = {
        beerId: this.beerId,
        ratingId: rating.ratingId,
        rating: rating.rating,
      };

      this.$webConn.request('app2_save_user_rating', data).then((result) => {

      }).catch((error) => {
        alert(error.Message);
      });
    },
    onTastingNotesChange() {
      const data = {
        beerId: this.beerId,
        notes: this.details.notes,
      };

      this.$webConn.request('app2_save_tasting_notes', data).then((result) => {

      }).catch((error) => {
        alert(error.Message);
      });
    },
  },
  watch: {
    // 'details.ratingsUser.rating': function ratingChanged(val, oldVal) {
    //   console.log('rating');
    // },
    // 'details.ratingsUser': {
    //   handler(newVal, oldVal) {
    //     // console.log(newVal);
    //     // console.log(oldVal);
    //     const changed = newVal.filter((p, idx) => Object.keys(p).some((prop) => p[prop] !== oldVal[idx][prop]));
    //     // Log it
    //     console.log(changed);
    //   },
    //   deep: true,
    // },
  },
};
</script>
